import { Routes } from '@angular/router';
import { EditGroupeVarietalComponent } from './edit-groupe-varietal/edit-groupe-varietal.component';
import { ListeGroupesVarietauxComponent } from './liste-groupes-varietaux/liste-groupes-varietaux.component';

export const GROUPES_VARIETAUX_ROUTES_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP']
};

export const GROUPES_VARIETAUX_ROUTES: Routes = [
    { path: '', component: ListeGroupesVarietauxComponent, data: { roles: ['ORGANISME'] } },
    { path: 'edit/:id', component: EditGroupeVarietalComponent, data: { roles: ['ORGANISME'] } },
    { path: 'new', component: EditGroupeVarietalComponent, data: { roles: ['ORGANISME'] } }
];
